import { createApp } from 'vue';
import CommonPlugin from 'plugins/common-plugin';
import { i18n } from 'utils/i18n';
import store from 'stores/generic';
import BlockPagePlugin from 'plugins/block-page';

require('styles/pages/block-page.less');

const app = createApp({});

app.use(CommonPlugin);
app.use(store);
app.use(i18n);
app.use(BlockPagePlugin);

app.mount('#app');
